import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { authActions } from "../../store/auth";
import { endPoints, siteConfig } from "../../config/end-points";
import "./support.css";

const Support = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = `${endPoints.title} | Support`;
    dispatch(authActions.setLoaderStatus({ status: false }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="sup-page">
      <div className="container">
        {/* Header */}
        <div className="sup-header">
          <h2>Support</h2>
          <p>Get help and find answers to your questions</p>
        </div>

        {/* Support Card */}
        <div className="sup-card">
          <img
            src={endPoints.logo}
            alt={siteConfig.title}
            className="sup-logo"
          />
          <h3>How can we help you?</h3>
          <p className="sup-desc">
            Browse our help center for guides, tutorials, and troubleshooting — or reach out and we'll get back to you.
          </p>
          <a
            className="sup-cta"
            href="https://engageleads.zendesk.com/hc/en-us"
            target="_blank"
            rel="noreferrer"
          >
            Visit Help Center
            <i className="bi bi-arrow-up-right"></i>
          </a>
          <p className="sup-email">
            Or email us at{" "}
            <a href={`mailto:${siteConfig.supportEmail}`}>
              {siteConfig.supportEmail}
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Support;
